import React from 'react'
import TablaLiquidacionMercaderiaGrado3View from '../../components/listados/TablaLiquidacionMercaderiaGrado3View'

function LiquidacionMercaderiaGrado3 () {
  return (
    <TablaLiquidacionMercaderiaGrado3View />
  )
}

export default LiquidacionMercaderiaGrado3
